import styled from 'styled-components';

import { ModalHeading as DefaultModalHeading } from 'components/modal';

export const ModalHeading = styled(DefaultModalHeading)`
  font-size: 1rem;
  font-weight: ${Styles.fontWeight.normal};
  margin: 0;
  text-transform: capitalize;
`;
